export const userState = {
    isLoggedIn: false,
    loginStatus: -1,
    user: null
}